import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

import { APP_LANGUAGES, DEFAULT_LANGUAGE } from 'app/config/languages.config';
import { VocabularyService } from 'app/server/services/vocabulary.service';

@Component({
	selector: 'app-diploma-language-modal',
	imports: [FormsModule, NgSelectModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="modal-header">
			<h5 class="modal-title">{{ title | translate }}</h5>
			<button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<ng-select [items]="options" bindLabel="label" bindValue="value" [(ngModel)]="selected" [clearable]="false" [searchable]="false">
			</ng-select>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-outline-secondary btn-sm" (click)="activeModal.dismiss()">
				{{ 'common_btn_cancel' | translate }}
			</button>
			<button type="button" class="btn btn-primary btn-sm" (click)="activeModal.close(selected)">
				{{ 'multitenant_btn_generate' | translate }}
			</button>
		</div>
	`,
})
export class DiplomaLanguageModalComponent {
	@Input() title = 'common_swal_select_document_language_title';

	private _vocabularyService = inject(VocabularyService);

	selected = DEFAULT_LANGUAGE.code;
	/** Only the languages the backend actually has vocabulary/translation data for (single source of truth). */
	options = APP_LANGUAGES.filter(l => this._vocabularyService.supportedLangCodes.includes(l.code)).map(l => ({
		value: l.code,
		label: l.label,
	}));

	constructor(public activeModal: NgbActiveModal) {}
}
